import { css, LitElement, html } from 'lit';
import { query, property, customElement, state } from 'lit/decorators.js';

var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$3(target, key, result);
  return result;
};
class UUIModalElement extends LitElement {
  constructor() {
    super(...arguments);
    this.isOpen = false;
    this.isClosing = false;
    this.index = 0;
    this.uniqueIndex = 0;
    this._transitionDuration = 250;
    this.open = (event) => {
      event == null ? void 0 : event.preventDefault();
      event == null ? void 0 : event.stopImmediatePropagation();
      const openEvent = new CustomEvent("open", {
        cancelable: true
      });
      this.dispatchEvent(openEvent);
      if (openEvent.defaultPrevented)
        return;
      this._openModal();
    };
    this.close = (event) => {
      event == null ? void 0 : event.preventDefault();
      event == null ? void 0 : event.stopImmediatePropagation();
      const closeEvent = new CustomEvent("close", {
        cancelable: true
      });
      this.dispatchEvent(closeEvent);
      if (closeEvent.defaultPrevented)
        return;
      this._closeModal();
    };
  }
  get transitionDuration() {
    return this._transitionDuration;
  }
  set transitionDuration(value) {
    this._transitionDuration = value;
    this.style.setProperty(
      "--uui-modal-transition-duration",
      this._transitionDuration + "ms"
    );
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    if (!this.isClosing) {
      this.open();
    }
  }
  _openModal() {
    var _a, _b;
    this.isOpen = true;
    (_a = this._dialogElement) == null ? void 0 : _a.showModal();
    (_b = this._dialogElement) == null ? void 0 : _b.addEventListener("cancel", this.close);
  }
  _closeModal() {
    var _a;
    this.isClosing = true;
    this.isOpen = false;
    (_a = this._dialogElement) == null ? void 0 : _a.close();
    this.dispatchEvent(new CustomEvent("close-end"));
    this.remove();
  }
}
UUIModalElement.styles = [
  css`
      dialog {
        display: block;
        margin: 0;
        padding: 0;
        max-width: unset;
        max-height: unset;
        border: none;
      }
      dialog::backdrop {
        background: none;
        opacity: 0;
      }
      dialog::after {
        content: '';
        position: absolute;
        inset: 0;
        background-color: var(--uui-modal-color-backdrop, rgba(0, 0, 0, 0.5));
        pointer-events: none;
        opacity: 1;
        transition: opacity var(--uui-modal-transition-duration, 250ms);
        z-index: 1;
      }
      :host([index='0']) dialog::after {
        opacity: 0;
      }
    `
];
__decorateClass$3([
  query("dialog")
], UUIModalElement.prototype, "_dialogElement", 2);
__decorateClass$3([
  property({ type: Boolean, reflect: true, attribute: "is-open" })
], UUIModalElement.prototype, "isOpen", 2);
__decorateClass$3([
  property({ type: Boolean, reflect: true, attribute: "is-closing" })
], UUIModalElement.prototype, "isClosing", 2);
__decorateClass$3([
  property({ type: Number, reflect: true })
], UUIModalElement.prototype, "index", 2);
__decorateClass$3([
  property({ type: Number, reflect: true, attribute: "unique-index" })
], UUIModalElement.prototype, "uniqueIndex", 2);
__decorateClass$3([
  property({ type: Number, attribute: "transition-duration" })
], UUIModalElement.prototype, "transitionDuration", 1);

var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
var __accessCheck$1 = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet$1 = (obj, member, getter) => {
  __accessCheck$1(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd$1 = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod$1 = (obj, member, method) => {
  __accessCheck$1(obj, member, "access private method");
  return method;
};
var _getWidth, getWidth_get, _onClose$1, onClose_fn;
let UUIModalSidebarElement = class extends UUIModalElement {
  constructor() {
    super();
    __privateAdd$1(this, _getWidth);
    __privateAdd$1(this, _onClose$1);
    this.size = "full";
    this.addEventListener("close", __privateMethod$1(this, _onClose$1, onClose_fn).bind(this));
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    this.style.setProperty("--uui-modal-offset", -__privateGet$1(this, _getWidth, getWidth_get) + "px");
  }
  updated(_changedProperties) {
    super.updated(_changedProperties);
    if (this.uniqueIndex > 10) {
      this.setAttribute("hide", "");
    } else {
      this.removeAttribute("hide");
    }
  }
  render() {
    return html`<dialog>
      <slot></slot>
    </dialog>`;
  }
};
_getWidth = new WeakSet();
getWidth_get = function() {
  var _a, _b;
  return (_b = (_a = this._dialogElement) == null ? void 0 : _a.getBoundingClientRect().width) != null ? _b : 0;
};
_onClose$1 = new WeakSet();
onClose_fn = function(event) {
  event.preventDefault();
  if (this.isClosing)
    return;
  this.isClosing = true;
  this.style.setProperty("--uui-modal-offset", -__privateGet$1(this, _getWidth, getWidth_get) + "px");
  setTimeout(() => {
    this._closeModal();
  }, this.transitionDuration);
};
UUIModalSidebarElement.styles = [
  ...UUIModalElement.styles,
  css`
      :host {
        --uui-modal-sidebar-left-gap: 24px;
      }
      @media (min-width: 600px) {
        :host {
          --uui-modal-sidebar-left-gap: 64px;
        }
      }
      dialog {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        max-width: calc(100% - var(--uui-modal-sidebar-left-gap));
        margin-left: auto;
        right: var(--uui-modal-offset);
        transition: right var(--uui-modal-transition-duration, 250ms);
      }
      :host([index='0']) dialog {
        box-shadow: var(--uui-shadow-depth-5,0 19px 38px rgba(0,0,0,0.30) , 0 15px 12px rgba(0,0,0,0.22));
      }
      :host(:not([index='0'])) dialog {
        outline: 1px solid rgba(0, 0, 0, 0.1);
      }
      :host([hide]) dialog {
        display: none;
      }
      :host([size='large']) dialog {
        max-width: min(1200px, calc(100% - var(--uui-modal-sidebar-left-gap)));
      }
      :host([size='medium']) dialog {
        max-width: min(800px, calc(100% - var(--uui-modal-sidebar-left-gap)));
      }
      :host([size='small']) dialog {
        max-width: min(400px, calc(100% - var(--uui-modal-sidebar-left-gap)));
      }
    `
];
__decorateClass$2([
  property({ reflect: true })
], UUIModalSidebarElement.prototype, "size", 2);
UUIModalSidebarElement = __decorateClass$2([
  customElement("uui-modal-sidebar")
], UUIModalSidebarElement);

var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _onSlotChange, _onClose, _updateModals, updateModals_fn, _updateSidebars, updateSidebars_fn;
let UUIModalContainerElement = class extends LitElement {
  constructor() {
    super();
    __privateAdd(this, _updateModals);
    __privateAdd(this, _updateSidebars);
    this.sidebarGap = 64;
    this.transitionDurationMS = 250;
    __privateAdd(this, _onSlotChange, () => {
      var _a, _b;
      this._modals = (_b = (_a = this.modalSlot) == null ? void 0 : _a.assignedElements({ flatten: true }).filter(
        (el) => el instanceof UUIModalElement
      )) != null ? _b : [];
      this._sidebars = this._modals.filter(
        (el) => el instanceof UUIModalSidebarElement
      );
      if (this._modals.length === 0) {
        this.removeAttribute("backdrop");
        return;
      }
      __privateMethod(this, _updateModals, updateModals_fn).call(this);
      __privateMethod(this, _updateSidebars, updateSidebars_fn).call(this);
    });
    __privateAdd(this, _onClose, () => {
      if (!this._modals || this._modals.length <= 1) {
        this.removeAttribute("backdrop");
        return;
      }
      __privateMethod(this, _updateModals, updateModals_fn).call(this);
      __privateMethod(this, _updateSidebars, updateSidebars_fn).call(this);
    });
    this.addEventListener("close", __privateGet(this, _onClose));
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    this.style.setProperty(
      "--uui-modal-transition-duration",
      this.transitionDurationMS + "ms"
    );
  }
  render() {
    return html`<slot @slotchange=${__privateGet(this, _onSlotChange)}></slot>`;
  }
};
_onSlotChange = new WeakMap();
_onClose = new WeakMap();
_updateModals = new WeakSet();
updateModals_fn = function() {
  var _a, _b;
  this.setAttribute("backdrop", "");
  const reverse = (_b = (_a = this._modals) == null ? void 0 : _a.filter((modal) => !modal.isClosing).reverse()) != null ? _b : [];
  reverse == null ? void 0 : reverse.forEach((modal, index) => {
    modal.index = index;
    modal.transitionDuration = this.transitionDurationMS;
  });
  reverse == null ? void 0 : reverse.forEach((modal) => {
    var _a2;
    const sameType = reverse == null ? void 0 : reverse.filter(
      (m) => m.constructor.name === modal.constructor.name
    );
    modal.uniqueIndex = (_a2 = sameType == null ? void 0 : sameType.indexOf(modal)) != null ? _a2 : 0;
  });
};
_updateSidebars = new WeakSet();
updateSidebars_fn = function() {
  requestAnimationFrame(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let sidebarOffset = 0;
    const reversed = (_b = (_a = this._sidebars) == null ? void 0 : _a.filter((modal) => !modal.isClosing).reverse()) != null ? _b : [];
    for (let i = 0; i < reversed.length; i++) {
      const sidebar = reversed[i];
      const nextSidebar = reversed[i + 1];
      sidebar.style.setProperty("--uui-modal-offset", sidebarOffset + "px");
      if (nextSidebar == null ? void 0 : nextSidebar.hasAttribute("hide"))
        break;
      const currentWidth = (_e = (_d = (_c = sidebar.shadowRoot) == null ? void 0 : _c.querySelector("dialog")) == null ? void 0 : _d.getBoundingClientRect().width) != null ? _e : 0;
      const nextWidth = (_h = (_g = (_f = nextSidebar == null ? void 0 : nextSidebar.shadowRoot) == null ? void 0 : _f.querySelector("dialog")) == null ? void 0 : _g.getBoundingClientRect().width) != null ? _h : 0;
      const distance = currentWidth + sidebarOffset + this.sidebarGap - nextWidth;
      sidebarOffset = distance > 0 ? distance : 0;
    }
  });
};
UUIModalContainerElement.styles = css`
    :host {
      position: fixed;
      --uui-modal-color-backdrop: rgba(0, 0, 0, 0.5);
    }
    :host::after {
      content: '';
      position: fixed;
      inset: 0;
      background-color: var(--uui-modal-color-backdrop, rgba(0, 0, 0, 0.5));
      opacity: 0;
      pointer-events: none;
      transition: opacity var(--uui-modal-transition-duration, 250ms);
    }
    :host([backdrop])::after {
      opacity: 1;
    }
  `;
__decorateClass$1([
  query("slot")
], UUIModalContainerElement.prototype, "modalSlot", 2);
__decorateClass$1([
  state()
], UUIModalContainerElement.prototype, "_modals", 2);
__decorateClass$1([
  state()
], UUIModalContainerElement.prototype, "_sidebars", 2);
__decorateClass$1([
  property({ type: Number })
], UUIModalContainerElement.prototype, "sidebarGap", 2);
__decorateClass$1([
  property({ type: Number })
], UUIModalContainerElement.prototype, "transitionDurationMS", 2);
UUIModalContainerElement = __decorateClass$1([
  customElement("uui-modal-container")
], UUIModalContainerElement);

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let UUIModalDialogElement = class extends UUIModalElement {
  render() {
    return html`
      <dialog>
        <slot></slot>
      </dialog>
    `;
  }
};
UUIModalDialogElement.styles = [
  ...UUIModalElement.styles,
  css`
      dialog {
        margin: auto;
        max-width: 100%;
        max-height: 100%;
        border-radius: 12px;
      }
      :host([index='0']) dialog {
        box-shadow: var(--uui-shadow-depth-5,0 19px 38px rgba(0,0,0,0.30) , 0 15px 12px rgba(0,0,0,0.22));
      }
      :host(:not([index='0'])) dialog {
        outline: 1px solid rgba(0, 0, 0, 0.1);
      }
    `
];
UUIModalDialogElement = __decorateClass([
  customElement("uui-modal-dialog")
], UUIModalDialogElement);

export { UUIModalContainerElement, UUIModalDialogElement, UUIModalElement, UUIModalSidebarElement };
